import type { Chord } from '@tunasong/music-lib'
import { ChordLib, ScaleLib, isChordVariant } from '@tunasong/music-lib'
import type { Scale } from '@tunasong/schemas'
import cn from 'classnames'
import type { CSSProperties, FC, MouseEvent } from 'react'
import React from 'react'
import { NoteDegree } from '../note/index.js'
import styles from './simple-chord.module.css'

export interface SimpleChordProps {
  chord: Chord
  /** Transpose the display by a number of semitones ( + / - ) */
  transpose?: number
  /** Display transposition as part of the chord (+/-)transposition */
  showTranspose?: boolean
  scale?: Scale | null
  selected?: boolean
  focused?: boolean
  className?: string
  style?: CSSProperties
  onClick?(chord: Chord): void
}

export const SimpleChord: FC<SimpleChordProps> = props => {
  const {
    chord,
    scale,
    showTranspose: _showTranspose = false,
    transpose = 0,
    selected = false,
    focused = false,
    className,
    style,
    onClick,
  } = props

  const chordName = ChordLib.getName(chord, transpose)

  const inScale = scale ? ScaleLib.inScale(scale, chord) : true
  /** We don't know that the root is in the custom chord, so we cannot calculate the degree */
  const degree = isChordVariant(chord) && scale && inScale && ScaleLib.getChordDegree(scale, chord)
  const handleClick = onClick
    ? (ev: MouseEvent) => {
        ev.preventDefault()
        onClick(chord)
      }
    : undefined

  return (
    <span
      contentEditable={false}
      onClick={handleClick}
      className={cn(
        styles.chord,
        inScale ? styles['chord--inScale'] : styles['chord--outOfScale'],
        selected && focused && styles['chord--selected'],
        onClick && styles['chord--clickable'],
        className
      )}
      style={style}
    >
      {chordName}
      {degree ? <NoteDegree degree={degree} /> : null}
    </span>
  )
}
